module.exports = __webpack_public_path__ + "img/intro-video.f719e0e6.gif";